<template>
	<div class="bg-white">
	  <div class="chat-container w-100  bg-white  hide-scroll overflow-scroll">
	    <div class="bg-green" style="height: 150px;">
	      <div class="w-100">
	        <div class="row w-100">
	          <div class="cursor-pointer" @click="backToHome()">
	            <div class="col-1">
	              <div class="nav-back" style="top: 12px!important;margin-left: 10px!important">
	                <img src="../../assets/img/icon/back-white.png" width="25">
	              </div>
	            </div>
	          </div>
	          <div class="col-9 py-14px">
	            <p class="text-white body-1-2 mb-0 text-truncate">Table Reservation</p>
	          </div>
	        </div>
	      </div>
	    </div>

	    <div class="container bg-white w-100" style="top: 45px;">
        <div class="position-relative" style="top: -100px">
	        <div class="bg-green rounded-50 p-4 mx-auto position-relative bullet"></div>
	        <div class="bg-white rounded-10 position-relative" style="margin-top: -10px;">
	          <div class="box-shadow-bold rounded-10">
	          	<div class="bg-white mx-3 py-2 mt-1 rounded-6 ">
		            <loader v-if="is_load" />
		            <div v-else class="px-3 py-3">
		            	<div class="row no-gutters border-bottom">
		                <div class="col-10">
		                  <div class="pr-3 pb-3">
		                    <p class="mb-0 font-semibold ls-0-15 text-20">{{getMerchant.name}}</p>
		                    <p class="mb-0 body-2-2-1 text-12">{{getMerchant.address}}</p>
		                  </div>
		                </div>
		                <div class="col-2">
		                  <img :src="getMerchant.image_url" class="w-100"
		                        style="vertical-align: -webkit-baseline-middle;">
		                </div>
		              </div>

		              <div class="w-100 mb-4">
			              <p class="my-3 color-black body-2 mb-3">Reservation Status</p>
			              <p class="mb-0 sub-heading-1-1" :class="parsingStatus(data.status,data.merchant_note).class">{{parsingStatus(data.status,data.merchant_note).status}}</p>
                    <p class="mb-0 body-3-3">{{parsingStatus(data.status,data.merchant_note).msg}}</p>
			            </div>
		              <div class="w-100 mb-4">
			              <p class="my-3 color-black body-2">Reservation Detail</p>
			              <div class="border-bottom pb-3">
			                <div class="row slim-grid-row mb-2">
			                  <div class="col-1">
			                    <img src="../../assets/img/icon/qr-code.png" class="d-inline-block" width="15">
			                  </div>
			                  <div class="col-8">
			                    <p class="mb-0 text-green sub-heading-1-1">{{data.reservation_id}}</p>
			                    <p class="mb-0 body-3-3 color-black">Reservation ID</p>
			                  </div>
			                </div>
			                <div class="row slim-grid-row mb-2">
			                  <div class="col-1">
			                    <img src="../../assets/img/icon/calendar-green.png" class="d-inline-block" width="15">
			                  </div>
			                  <div class="col-8">
			                    <p class="mb-0 text-green sub-heading-1-1">{{customFormatDateTime(data.book_date,'dddd')}}</p>
			                    <p class="mb-0 body-3-3 color-black">{{customFormatDateTime(data.book_date,'D MMMM YYYY')}}</p>
			                  </div>
			                </div>
			                <div class="row slim-grid-row mb-2">
			                  <div class="col-1">
			                    <img src="../../assets/img/icon/time.png" class="d-inline-block" width="15">
			                  </div>
			                  <div class="col-8">
			                    <p class="mb-0 text-green sub-heading-1-1">{{customFormatDateTime(data.book_date,'HH:mm')}}</p>
			                    <p class="mb-0 body-3-3 color-black">According to local time</p>
			                  </div>
			                </div>
			                <div class="row slim-grid-row mb-2">
			                  <div class="col-1">
			                    <img src="../../assets/img/icon/group.png" class="d-inline-block" width="16">
			                  </div>
			                  <div class="col-8">
			                    <p class="mb-0 text-green sub-heading-1-1">For {{data.guest_detail.adult}} adult <template v-if="data.guest_detail.child > 0">and {{data.guest_detail.child}} child</template></p>
			                  </div>
			                </div>
			                <div class="row slim-grid-row mb-2" v-if="data.note != ''">
			                  <div class="col-1">
			                    <img src="../../assets/img/icon/sticker.png" class="d-inline-block" width="15">
			                  </div>
			                  <div class="col-11">
			                    <p class="mb-0 body-3-3 text-14 mt-1">{{data.note}}</p>
			                  </div>
			                </div>
			              </div>
			            </div>
			            <div class="w-100">
			              <p class="mt-4 mb-2 color-black body-2">Contact Detail</p>
			              <p class="mb-0 sub-heading-1-1 color-black">{{data.customer_detail.title}} {{data.customer_detail.first_name}} {{data.customer_detail.last_name}}</p>
			              <p class="mb-0 body-2-2 text-light-bold">{{data.customer_detail.email}} | {{data.customer_detail.phone_number}}</p>
			            </div>
		            </div>
		          </div>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	import { get } from "@/services/index.js";
	import moment from 'moment'

	export default{
		data(){
			return{
				is_load: true,
				data: {},
				error: ''
			}
		},
		computed:{
			...mapGetters(['getMerchant'])
		},
		mounted(){
			this.loadDetailData()
		},
		methods:{
			customFormatDateTime(date,format){
        let DateUtc = moment.utc(date);
        return moment(DateUtc,"YYYY-MM-DDTHH:mm:ssZ").format(format)
      },
      parsingStatus(data,msg){
      	if(data == 'PENDING'){
      		return {
      			status: 'Waiting for confirmation',
      			msg: 'Please wait while our staff checks your reservation',
      			class: 'text-orange'
      		}
      	}else if(data == 'SUCCESS'){
      		return {
      			status: 'Confirmed',
      			msg: 'Your reservation has been confirmed. Please contact us if you have any changes',
      			class: 'text-green'
      		}
      	}else if(data == 'CANCELLED'){
      		return {
      			status: 'Cancelled',
      			msg: msg,
      			class: 'text-danger'
      		}
      	}else{
      		return {
      			status: data,
      			msg: '',
      			class: 'text-info'
      		}
      	}
      },
      backToHome(){
      	this.$router.push(`/${this.getMerchant.code}`)
      },
			loadDetailData(){
				this.is_load = true
				this.error = ''
				get("CORE_RESTO",`v2/booking-table/status/${this.$route.params.book_id}`).then(response=>{
					let res = response.data
					if(res.success){
						this.data = res.data
					}else{
						this.error = res.message
					}
					this.is_load = false
				})
			}
		}
	}
</script>
<style scoped>
  .bullet{
    width: 50px;
    height: 50px;
    z-index: 99
  }

  .text-light-bold{
    color: #414955A6!important
  }
  .color-black {
    color: #000;
  }
</style>


// WEBPACK FOOTER //
// src/pages/restaurant/ResultBookTable.vue